export const normalizeEmail = (email: string) => email?.toLowerCase()?.trim();

export const capitalizeWords = (input: string): string => {
  if (!input) return input;

  return input
    .split(' ') // Split the input string into an array of words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter and lowercase the rest of each word
    .join(' '); // Join the processed words back into a string
};

export const sanitize = (input: string): string =>
  input
    .replace(/[^a-zA-Z0-9]+/g, ' ') // Replace non-alphanumeric characters with a space
    .trim() // Trim leading and trailing spaces
    .toLowerCase()
    .replace(/ /g, '_'); // Replace spaces with underscores
